import { useEffect, useState } from 'react'
import { useNavigate, useSearchParams } from 'react-router-dom'
import { SSOLogin } from '../../components/Auth/SSOLogin'
import { toast } from '../../components/Toast'
import { authService } from '../../services/auth'
import { useAuthStore } from '../../store/auth'
import { WavesBackground } from '../../components/Layout/WavesBackground'
import logoSistemaCasas from '../../assets/logo-sistema-fieac-casas.png'
import Hermesextenso from '../../assets/hermesextenso.svg'

export const LoginPage = () => {
  const navigate = useNavigate()
  const [searchParams] = useSearchParams()
  const [, setIsLoading] = useState(false)
  const { setAuth, isAuthenticated } = useAuthStore()

  // Se já está autenticado, redirecionar para home
  useEffect(() => {
    if (isAuthenticated && authService.getToken()) {
      navigate('/', { replace: true })
    }
  }, [isAuthenticated, navigate])

  useEffect(() => {
    const error = searchParams.get('error')
    const success = searchParams.get('sso')
    const token = searchParams.get('token')

    // Tratar diferentes tipos de erro
    if (error) {
      switch (error) {
        case 'unauthorized_domain':
          toast.error('Email não autorizado. Use seu email corporativo (@fieac.org.br).')
          break
        case 'sso_failed':
          toast.error('Falha na autenticação. Tente novamente.')
          break
        case 'sso_not_linked':
          toast.error(
            'Sua conta Microsoft não está vinculada a um usuário no sistema. Entre em contato com o administrador.'
          )
          break
        case 'no_email':
          toast.error('Não foi possível obter o email da conta Microsoft.')
          break
        case 'no_code':
          toast.error('Código de autorização não recebido. Tente novamente.')
          break
        default:
          toast.error('Erro na autenticação. Tente novamente.')
          break
      }
      // Limpar apenas parâmetros de erro
      navigate('/login', { replace: true })
    } else if (success === 'success' && token) {
      // SSO bem-sucedido - processar login
      const processLogin = async () => {
        try {
          // Salvar token
          authService.setToken(token)

          // Buscar dados do usuário para validar o token
          const user = await authService.getCurrentUser()

          // Salvar dados completos
          authService.saveAuth(token, user)

          // Atualizar store Zustand
          setAuth(token, user)

          // Limpar URL e navegar para home
          navigate('/', { replace: true })
        } catch (error) {
          console.error('Erro ao processar login SSO:', error)
          toast.error('Erro ao validar autenticação. Tente novamente.')
          // Limpar token inválido
          authService.clearAuth()
          navigate('/login', { replace: true })
        }
      }

      processLogin()
    }
  }, [searchParams, navigate, setAuth])

  return (
    <div className='flex min-h-screen items-center justify-center p-4 sm:px-6 lg:px-8'>
      <WavesBackground forceTheme='light' />

      <div className='bg-white rounded-2xl max-w-md w-full space-y-8 p-8 py-12 shadow-2xl relative z-10'>
        <div className='space-y-6'>
          {/* Logo */}
          <div className='flex justify-center'>
            <img src={logoSistemaCasas} alt='Logo Sistema FIEAC' className='h-15 w-auto' />
          </div>

          {/* Título e Descrição */}
          <div className='flex flex-col items-center'>
            <h2 className='text-center text-3xl font-extrabold text-gray-900'>
              Sistema{' '}
            </h2>
              <span>
                <img src={Hermesextenso} alt='Hermes por Extenso' className='h-20' />
              </span>
          </div>
        </div>

        {/* Botão de Login */}
        <div className='rounded-lg'>
          <SSOLogin onLoading={setIsLoading} />
        </div>
      </div>
    </div>
  )
}
